module.exports = __webpack_public_path__ + "img/company-logo.69aae40c.svg";